import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonText,
  IonNote,
} from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { usePageView } from '../hooks/useLoggerInit';
import { useI18n } from '../i18n/I18nProvider';
import { API_COMPAT } from '../lib/apiCompat';

const UpgradePage: React.FC = () => {
  const { t } = useI18n();
  const location = useLocation();
  const force = new URLSearchParams(location.search).get('force') === '1';

  usePageView('upgrade');

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          {!force && (
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" text={t('common.actions.back')} />
            </IonButtons>
          )}
          <IonTitle>{t('versionCompat.upgrade.title')}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className="ion-padding">
        <h1>{t('versionCompat.upgrade.headline')}</h1>
        <IonText color="medium">
          <p>
            {force
              ? t('versionCompat.upgrade.forceSubhead')
              : t('versionCompat.upgrade.subhead')}
          </p>
        </IonText>

        <IonNote>
          {t('versionCompat.upgrade.requiredLabel')}:{' '}
          <strong>{API_COMPAT.requiredBackendVersion}</strong>
        </IonNote>

        <IonList lines="none" className="ion-margin-top">
          <IonItem>
            <IonLabel className="ion-text-wrap">
              <h2>{t('versionCompat.upgrade.web.title')}</h2>
              <p>{t('versionCompat.upgrade.web.body')}</p>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel className="ion-text-wrap">
              <h2>{t('versionCompat.upgrade.pwa.title')}</h2>
              <p>{t('versionCompat.upgrade.pwa.body')}</p>
            </IonLabel>
          </IonItem>
          <IonItem>
            <IonLabel className="ion-text-wrap">
              <h2>{t('versionCompat.upgrade.native.title')}</h2>
              <p>{t('versionCompat.upgrade.native.body')}</p>
            </IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default UpgradePage;
